import type { LineGroup } from './types';

export function GroupDisplay({
  group,
  isCurrent,
  isUpcoming,
}: {
  group: LineGroup;
  isCurrent: boolean;
  isUpcoming: boolean;
}) {
  const { line, chordText } = group;
  const className = [
    'perf-line',
    isCurrent ? 'perf-line-current' : '',
    isUpcoming ? 'perf-line-upcoming' : '',
    !isCurrent && !isUpcoming ? 'perf-line-past' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const isSectionHeader = line.type === 'section' || /^\[.+\]$/.test(line.text.trim());

  return (
    <div className={className}>
      {/* Chord line rendered at the same monospace font-size as lyrics so columns align */}
      {chordText && (
        <span className="perf-chord-line" aria-hidden="true">
          {chordText}
        </span>
      )}
      {isSectionHeader ? (
        <span className="perf-section-header">{line.text}</span>
      ) : (
        <span className="perf-lyric-text">{line.text || '\u00A0'}</span>
      )}
    </div>
  );
}
